<template>
  <div id="rootDiv">
    <!-- <nav-head></nav-head> -->
    <a-table
      :columns="columns"
      :data-source="algs"
      :pagination="false"
      class="contentDiv"
      v-if="algs.length > 0"
    >
      <span slot="name" slot-scope="name, record, i">
        {{ name }}
        <a-tag v-for="tag in algs[i].tags" color="green" :key="tag">{{
          tag
        }}</a-tag>
      </span>
      <span slot="action" slot-scope="alg">
        <a-button type="primary" class="algOperation" @click="trainNew(alg.id)"
          >训练实例</a-button
        >
        <a-button
          type="primary"
          class="algOperation"
          @click="toHelpPage(alg.id)"
          >算法文档</a-button
        >
      </span>
      <span slot="input_type" slot-scope="text">
        <a-tooltip>
          <template slot="title"> {{ inputExplain(text) }}</template>
          {{ inputType(text) }}
          <a-icon type="question-circle" theme="twoTone" />
        </a-tooltip>
      </span>
    </a-table>
  </div>
</template>

<script>
import util from '../util'
export default {
  data() {
    return {
      algs: [],
      columns: [
        {
          title: '算法名',
          key: 'name',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
          // customRender: function(text, record, index) {
          //   return { text: text, index: index }
          // }
        },
        {
          title: '创建时间',
          key: 'time',
          dataIndex: 'time',
          customRender: function(text, record, index) {
            return text.split('T')[0]
          }
        },
        {
          title: '输入类型',
          key: 'input_type',
          dataIndex: 'input_type',
          scopedSlots: { customRender: 'input_type' }
          // customRender: function(text, record, index) {
          //   return text === 'table2d' ? '二维表' : '其它'
          // }
        },
        {
          title: '',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    async getAlgs() {
      const resp = await this.$http.get('algorithms')
      this.algs = resp.data
    },
    trainNew(aid) {
      this.$router.push('/train/' + aid)
    },
    toHelpPage(aid) {
      util.toAlgHelp(aid, this.$router)
    },
    inputType(t) {
      switch (t) {
        case 'table2d':
          return '二维表'
        default:
          return '其他'
      }
    },
    inputExplain(t) {
      switch (t) {
        case 'table2d':
          return 'excel或csv文件，第一行是表头，表示字段名，其余每行表示一条记录'
        default:
          return '其他'
      }
    }
  },
  created() {
    this.getAlgs()
  }
}
</script>

<style scoped>
.contentDiv {
  padding: 0 1rem 4rem 1rem;
}
.algOperation {
  margin-right: 0.8rem;
  font-size: 0.8rem;
  height: 1.4rem;
  padding: 0 0.3rem 0 0.3rem;
}
</style>
